import React from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import demoBase64 from '../../../mock/demoBase64';
import Loading from '../../common/loading';
import Female from '../../../asset/img/female-icon.png';
import Male from '../../../asset/img/male-icon.png';
import Currencies from '../../../constants/currencies';
import userContainer from '../../../containers/user/info';
import { withNamespaces } from 'react-i18next';

class UserInfo extends React.Component {
  constructor(props) {
    super(props);

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);

    const totalTravelExpense = (
      parseInt(this.props.requestStats.pending)
      + parseInt(this.props.requestStats.rejected)
      + parseInt(this.props.requestStats.approved)
      + parseInt(this.props.requestStats.accounting)
      + parseInt(this.props.requestStats.accountingCancelled)
      + parseInt(this.props.requestStats.waitingForCancelled)
      + parseInt(this.props.requestStats.cancelled)
    );

    const totalPendingTravelExpense = (
      parseInt(this.props.requestStats.pending)
      + parseInt(this.props.requestStats.accounting)
      + parseInt(this.props.requestStats.accountingCancelled)
      + parseInt(this.props.requestStats.waitingForCancelled)
    );

    this.state = {
      approvedTravelExpense: this.props.requestStats.approved,
      rejectedTravelExpense: this.props.requestStats.rejected,
      pendingTravelExpense: totalPendingTravelExpense,
      accountingTravelExpense: this.props.requestStats.accounting,
      accountingCancelledTravelExpense: this.props.requestStats.accountingCancelled,
      waitingCancelledTravelExpense: this.props.requestStats.waitingForCancelled,
      cancelledTravelExpense: this.props.requestStats.cancelled,
      totalTravelExpense
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.requestStats !== nextProps.requestStats) {
      const totalTravelExpense = (
        parseInt(nextProps.requestStats.pending)
        + parseInt(nextProps.requestStats.rejected)
        + parseInt(nextProps.requestStats.approved)
        + parseInt(nextProps.requestStats.accounting)
        + parseInt(nextProps.requestStats.accountingCancelled)
        + parseInt(nextProps.requestStats.waitingForCancelled)
        + parseInt(nextProps.requestStats.cancelled)
      );

      const totalPendingTravelExpense = (
        parseInt(nextProps.requestStats.pending)
        + parseInt(nextProps.requestStats.accounting)
        + parseInt(nextProps.requestStats.accountingCancelled)
        + parseInt(nextProps.requestStats.waitingForCancelled)
      );

      this.setState({
        approvedTravelExpense: nextProps.requestStats.approved,
        rejectedTravelExpense: nextProps.requestStats.rejected,
        pendingTravelExpense: totalPendingTravelExpense,
        accountingTravelExpense: nextProps.requestStats.accounting,
        accountingCancelledTravelExpense: nextProps.requestStats.accountingCancelled,
        waitingCancelledTravelExpense: nextProps.requestStats.waitingForCancelled,
        cancelledTravelExpense: nextProps.requestStats.cancelled,
        totalTravelExpense

      });
    }
  }

  onMouseEnter(e) {
    const getTarget = e.currentTarget.dataset.target;

    $(getTarget)
      .stop()
      .slideDown(200);
  }

  onMouseLeave(e) {
    const getTarget = e.currentTarget.dataset.target;

    $(getTarget)
      .stop()
      .slideUp(200);
  }

  render() {
    const { auth, requestStats,t } = this.props;

    const { user } = auth;
    const { userCurrency } = requestStats;

    return (
      <div className="card card-user">
        <div className="image" style={auth.user.gender === 'Female' ? { backgroundColor: '#EB5E28' } : {}} />
        <div className="content">
          <div className="author">
            <img
              className="avatar border-white"
              src={auth.user.gender === 'Female' ? Female : auth.user.gender === 'Male' ? Male : demoBase64}
              alt="..."
            />
            <Loading rows={2} loading={auth.loading}>
              <h4 className="title">
                {auth.user.employeeName}
                <br />
                <small>
                  {auth.user.unitName}
                </small>
              </h4>
            </Loading>
          </div>
        </div>
        <div className="content text-left">
          <Loading rows={4} loading={auth.loading}>
            <ul className="list-unstyled team-members">
              <li>
                <h6>
                  {t("groupName")}:
                  <span className="pull-right">
                    {user && user.harcirahGroupLimits && user.harcirahGroupLimits.harcirahGrup}
                  </span>
                </h6>
              </li>
              <li>
                <h6>
                  {t("domesticAccommodationLimit")}:
                  <span className="pull-right">
                    {user && user.harcirahGroupLimits && user.harcirahGroupLimits.YurticiBireyselKonaklamaLimitleri[0]}
                    {' '}
                    ₺
                  </span>
                </h6>
              </li>
              <li
                data-target="#yurtdisi-bireysel-konaklama"
                onMouseLeave={this.onMouseLeave}
                onMouseEnter={this.onMouseEnter}
              >
                <h6>
                  {t("overseasAccommodationLimits")}:
                  <span className="pull-right">
                    <span className="fa fa-angle-down" />
                  </span>
                </h6>
                <ul
                  id="yurtdisi-bireysel-konaklama"
                  className="list-unstyled team-members"
                  style={{
                    marginTop: '10px',
                    padding: '10px',
                    background: '#f9f9f9',
                    display: 'none',
                  }}
                >
                  {
                    user && user.harcirahGroupLimits && user.harcirahGroupLimits.YurtdisiBireyselKonaklamaLimitleri.length
                    > 0
                      ? user && user.harcirahGroupLimits && user.harcirahGroupLimits.YurtdisiBireyselKonaklamaLimitleri.map(
                        (limit, key) => (
                        /* eslint-disable react/no-array-index-key */
                          <li key={key}>
                            <h6>
                              {limit.region}
                              {' '}
                              <span className="pull-right">
                                {limit.limit}
                                {' '}
                                {`${Currencies(limit.currency)}`}
                              </span>
                            </h6>
                          </li>
                        ))
                      : null
                  }
                </ul>
              </li>
              <li>
                <h6>
                  {t("domesticAllowanceLimit")}:
                  <span className="pull-right">
                    {user && user.harcirahGroupLimits && user.harcirahGroupLimits.YurticiHarcirahLimitleri[0]}
                    {' '}
                    ₺
                  </span>
                </h6>
              </li>
              <li
                data-target="#yurtdisi-harcirah-limiti"
                onMouseLeave={this.onMouseLeave}
                onMouseEnter={this.onMouseEnter}
              >
                <h6>
                  {t("overseasAllowanceLimit")}:
                  <span className="pull-right">
                    <span className="fa fa-angle-down" />
                  </span>
                </h6>
                <ul
                  id="yurtdisi-harcirah-limiti"
                  className="list-unstyled team-members"
                  style={{
                    marginTop: '10px',
                    padding: '10px',
                    background: '#f9f9f9',
                    display: 'none',
                  }}
                >
                  {
                    user && user.harcirahGroupLimits && user.harcirahGroupLimits.YurtdisiHarcirahLimitleri.length
                    > 0
                      ? user && user.harcirahGroupLimits && user.harcirahGroupLimits.YurtdisiHarcirahLimitleri.map(
                        (limit, key) => (
                          <li key={key}>
                            <h6>
                              {limit.region}
                              {' '}
                              <span className="pull-right">
                                {limit.limit}
                                {' '}
                                {`${Currencies(limit.currency)}`}
                              </span>
                            </h6>
                          </li>
                        ))
                      : null
                  }
                </ul>
              </li>
            </ul>
          </Loading>
        </div>
        <hr />
        <div className="text-center">
          <Loading rows={1} loading={auth.loading}>
            <div className="row">
              <div className="col-md-3" style={{ marginLeft: '3%' }}>
                <h5>
                  {this.state.approvedTravelExpense}
                  <br />
                  <small>
                    {t("approved")}
                  </small>
                </h5>
              </div>
              <div className="col-md-3">
                <h5>
                  {this.state.rejectedTravelExpense}
                  <br />
                  <small>
                    {t("rejected")}
                  </small>
                </h5>
              </div>
              <div className="col-md-3">
                <h5>
                  {this.state.pendingTravelExpense}
                  <br />
                  <small>
                    {t("waiting")}
                  </small>
                </h5>
              </div>
              <div className="col-md-2">
                <h5>
                  {this.state.totalTravelExpense}
                  <br />
                  <small>
                    {t("total")}
                  </small>
                </h5>
              </div>
            </div>
          </Loading>
        </div>
      </div>
    );
  }
}


export default withNamespaces()(connect(...userContainer)(UserInfo));



// WEBPACK FOOTER //
// ./src/components/user/info/index.js